import { IconChevronDown, IconSettings } from '@tabler/icons-react';
import { signOut, useSession } from 'next-auth/react';
import { Avatar, Divider, Group, Menu, rem, Text, UnstyledButton } from '@mantine/core';
import classes from './UserButton.module.css';

export function UserButton() {
  const { data: session } = useSession();

  return (
    <Menu shadow="md" width={250} position="bottom-end">
      <Menu.Target>
        <UnstyledButton className={classes.user}>
          <Group>
            <Avatar src={session?.user?.image} radius="xl" />

            <IconChevronDown style={{ width: rem(14), height: rem(14) }} stroke={1.5} />
          </Group>
        </UnstyledButton>
      </Menu.Target>

      <Menu.Dropdown>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: 'var(--mantine-spacing-sm)',
          }}
        >
          <Avatar src={session?.user?.image} radius="xl" />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginLeft: rem(10),
              overflow: 'hidden',
              whiteSpace: 'nowrap',
            }}
          >
            <Text
              size="sm"
              fw={500}
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {session?.user?.name}
            </Text>
            <Text
              c="dimmed"
              size="xs"
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {session?.user?.email}
            </Text>
          </div>
        </div>
        <Divider />
        <Menu.Label>Application</Menu.Label>
        <Menu.Item
          onClick={() => {
            signOut();
          }}
          leftSection={<IconSettings style={{ width: rem(14), height: rem(14) }} />}
        >
          Logout
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
